export default "__VITE_ASSET__73gXMrqv__"